/**
 * Lays out a month for a Sunday-first calendar grid.
 * month is 0-based like Date#getMonth. Returns [{ day, column, row }], column 0 = Sunday.
 */
export function getCalendarDays(year, month) {
  const firstWeekday = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  return Array.from({ length: daysInMonth }, (_, index) => {
    const slot = firstWeekday + index;
    return { day: index + 1, column: slot % 7, row: Math.floor(slot / 7) };
  });
}
